import React from "react";
import { Reveal, WfButton, ImageWithCredit } from "@/components/site/primitives";
import { PROGRAMS } from "@/content/worldFarmers";
import { scrollToId } from "@/lib/scrollTo";

export const ProgramsV2 = () => {
  const { flats, mentorship } = PROGRAMS;
  const go = (id) => (e) => { e.preventDefault(); scrollToId(id); };
  return (
    <section id="programs" aria-labelledby="programs-v2-heading" className="wf-section bg-[var(--wf-cream)]">
      <div className="wf-container">
        <Reveal className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--wf-maroon)]">
            Hands-on & community-centered
          </span>
          <h2 id="programs-v2-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl lg:text-5xl">
            Our programs
          </h2>
        </Reveal>

        {/* Flats feature */}
        <Reveal>
          <div className="mt-10 grid grid-cols-1 overflow-hidden rounded-sm border border-[var(--wf-border)] bg-[var(--wf-paper)] shadow-[var(--wf-shadow-sm)] lg:grid-cols-2">
            <ImageWithCredit src={flats.image} alt={flats.alt} className="min-h-[280px] lg:min-h-full" imgClassName="h-full" />
            <div className="flex flex-col justify-center gap-4 p-7 sm:p-10">
              <span className="w-fit rounded-full bg-[var(--wf-wheat)] px-3 py-1 text-xs font-semibold text-[var(--wf-maroon)]">{flats.badge}</span>
              <h3 className="font-serif text-2xl font-semibold text-[var(--wf-ink)] sm:text-3xl">{flats.title}</h3>
              <p className="text-sm leading-6 text-muted-foreground">{flats.body}</p>
              <div className="mt-1">
                <WfButton as="a" href="#gallery" onClick={go("gallery")} variant="secondary" withArrow data-testid="programs-learn-more-button">
                  See the farm
                </WfButton>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Mentorship horizontal stepper */}
        <Reveal>
          <div className="mt-12 flex items-end justify-between gap-4">
            <div>
              <span className="w-fit rounded-full bg-[rgba(47,93,58,0.10)] px-3 py-1 text-xs font-semibold text-[var(--wf-green-text)]">{mentorship.badge}</span>
              <h3 className="mt-3 font-serif text-2xl font-semibold text-[var(--wf-ink)] sm:text-3xl">{mentorship.title}</h3>
            </div>
            <p className="hidden max-w-xs text-sm leading-6 text-muted-foreground md:block">{mentorship.body}</p>
          </div>
        </Reveal>

        <Reveal>
          <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-5">
            {mentorship.phases.map((p) => (
              <div
                key={p.n}
                data-testid={`program-phase-${p.n}`}
                className="group relative flex h-full flex-col overflow-hidden rounded-sm border border-[var(--wf-border)] bg-[var(--wf-paper)] p-5 shadow-[var(--wf-shadow-sm)] transition-[box-shadow,transform] duration-300 hover:shadow-[var(--wf-shadow)] motion-safe:hover:-translate-y-1.5"
              >
                <span className="relative flex h-11 w-11 items-center justify-center rounded-full bg-[var(--wf-maroon)] font-serif text-lg font-semibold text-[var(--wf-paper)]">{p.n}</span>
                <p className="relative mt-4 text-[11px] font-semibold uppercase tracking-[0.14em] text-[var(--wf-green-text)]">Phase {p.n}</p>
                <h4 className="relative mt-1 font-serif text-base font-semibold leading-snug text-[var(--wf-ink)]">{p.title}</h4>
                <p className="relative mt-2 text-xs leading-5 text-muted-foreground">{p.text}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
